/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, OnInit } from '@angular/core';
import {
  StepperRequest,
} from '../../my-requests/commons/interfaces/my-requests.interface';
import { Router } from '@angular/router';

@Component({
  selector: 'app-status-requirement',
  templateUrl: './status-requirement.component.html',
  styleUrls: ['./status-requirement.component.scss'],
})
export class StatusRequirementComponent implements OnInit {
  @Input() steps!: StepperRequest[];
  @Input() status!: string;
  @Input() viewRequest!: string;
  @Input() dataTableRequest!: any;
  @Input() idSelection!: any;

  progressBarData!: StepperRequest;

  constructor(private router: Router) {}

  ngOnInit() {
    this.progressBarData = this.getStepSelected(this.status);
  }

  getStepSelected(status: string): StepperRequest {
    const stepsRequest = this.steps.find((product) => product.status === status);
    if (stepsRequest) {
      return {
        percent: stepsRequest.percent,
        colorProgressBar: stepsRequest.colorProgressBar,
      };
    }
    return { percent: '', colorProgressBar: 'primary' };
  }

  goToRequest(num: any) {
    if (num === this.dataTableRequest.idCode) {
      this.router.navigate(['admin/requests/benefit-application/'+ this.dataTableRequest.idCode ]);
    }
  }

}
